import ImageCrop from 'components/Admin/DirectoryPage/ImageModal/ImageCrop'
import style from './style.module.scss'
import { Button, Header, Text } from '@crossfit/design-system'
import { useState } from 'react'
import Modal from 'react-modal'

export type ImageCropperProps = {
  imageFile: File
  isOpen: boolean
  close: () => void
  imageCropped: (File) => void
}

export default function ImageCropper({
  imageFile,
  isOpen,
  close,
  imageCropped,
}: ImageCropperProps) {
  const [croppedImage, setCroppedImage] = useState<File>(imageFile)

  return (
    <Modal
      style={{
        overlay: {
          zIndex: 10,
          backgroundColor: 'rgba(0, 0, 0, .7)',
        },
        content: {
          position: 'fixed',
          top: 'auto',
          left: '50%',
          bottom: '0',
          transform: 'translateX(-50%)',
          width: '100%',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
        },
      }}
      appElement={document.getElementById('app') as HTMLElement}
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
    >
      <div className={style.modalContent}>
        <div className={style.headerContainer}>
          <Header size='sm' as='h1' className={style.modalHeader}>
            UPLOAD
          </Header>
          <Text type='body' size='sm' bold>
            X
          </Text>
        </div>
        <div className={style.imagePreviewContainer}>
          <ImageCrop
            onCrop={setCroppedImage}
            file={imageFile}
            aspectRatio={1}
            disableGrid
          />
        </div>
        <div className={style.buttonContainer}>
          <Button variant='primary' onClick={() => imageCropped(croppedImage)}>
            Save Image
          </Button>
          <p className={style.cancelButton} onClick={close}>
            Cancel
          </p>
        </div>
      </div>
    </Modal>
  )
}
